/**
 * SC Image Carousel
 * Loop for all carousels on the DOM and assign the proper setup for the section carousel
 */
const carouselArray = document.querySelectorAll('.carousel');

carouselArray.forEach((item) => {
    // console.log(item.getAttribute('data-custompagination')); //- 'true' : 'false'
    // console.log(item.dataset.custompagination); //- 'true' : 'false'

    let myCarousel = item.childNodes[0].className;
    let myCarouselParent = item.getAttribute('id');

    // console.log(myCarouselParent);

    if (item.getAttribute('data-custompagination') == 'true') {
        // console.log("yes", item);

        $('#' + myCarouselParent + ' .' + myCarousel).slick({
            slidesToShow: parseInt(item.dataset.slidestoshow),
            slidesToScroll: parseInt(item.dataset.slidestoscroll),
            infinite: item.dataset.infinite == 'true' ? true : false,
            autoplay: item.dataset.autoplay == 'true' ? true : false,
            autoplaySpeed: parseInt(item.dataset.autoplayspeed),
            speed: parseInt(item.dataset.changeslidespeed),
            responsive: [
                {
                    breakpoint: 3000,
                    settings: {
                        dots: item.dataset.showdots == 'true' ? true : false,
                        arrows: item.dataset.showarrows == 'true' ? true : false,
                        appendDots: $(".carousel__customNav"),
                        customPaging: function (slick, i) {
                            let targetImage = $(slick.$slides[i]).data('img'),
                                targetAlt = $(slick.$slides[i]).data('alt');
                            return '<img data-src="' + targetImage + '" alt="' + targetAlt + '" class="carousel__customNavImg lazyload"/>';
                        }
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        dots: item.dataset.showdots == 'true' ? true : false,
                        arrows: false,
                        customPaging: function (slick, index) {
                            return $('<button type="button" />').text(index + 1);
                        }
                    }
                }
            ]
        });

    } else {
        // console.log("no", item);

        $('#' + myCarouselParent + ' .' + myCarousel).slick({
            slidesToShow: parseInt(item.dataset.slidestoshow),
            slidesToScroll: parseInt(item.dataset.slidestoscroll),
            infinite: item.dataset.infinite == 'true' ? true : false,
            autoplay: item.dataset.autoplay == 'true' ? true : false,
            autoplaySpeed: parseInt(item.dataset.autoplayspeed),
            speed: parseInt(item.dataset.changeslidespeed),
            dots: item.dataset.showdots == 'true' ? true : false,
            responsive: [
                {
                    breakpoint: 3000,
                    settings: {
                        arrows: item.dataset.showarrows
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });
    }
});

/**
 * Handle Video instances Play/Pause
 */
// Create array for player IDs
let players = [];

// Determine the available player IDs
for (let i = 0; i < Object.keys(videojs.players).length; i++) {
    // Assign the player name to setPlayer
    var setPlayer = Object.keys(videojs.players)[i];

    // Define the ready event for the player
    videojs.getPlayer(setPlayer).ready(function () {
        // Assign this player to a variable
        let myPlayer = this;

        //- Assign Slick controls to a variable
        let slickArrow = $('.slick-arrow');
        let slickDots = $('.slick-dots li');

        // Assign and event listener for play event
        myPlayer.on("play", onPlay);

        slickArrow.on("click", onPlay);
        slickDots.on("click", onPlay);

        // Push the player to the players array
        players.push(myPlayer);
    });
}

// Handle all players' play event 
function onPlay(e) {
    // Determine which player the event is coming from
    var id = e.target.id;

    // Loop through the array of players
    for (let x = 0; x < players.length; x++) {
        // Get the player(s) that did not trigger the play event
        if (players[x].id() != id) {
            // Pause the other player(s)
            videojs(players[x].id()).pause();
        }
    }
}